import { reactive } from 'vue';

export const useYearOption = () => {
    const yearOption = reactive([]);

    const recordStartYear = 2023;

    const currentYear = new Date().getFullYear();

    const setYearOption = () => {
        yearOption.length = 0;
        for (let i = recordStartYear; i <= currentYear; i += 1) {
            yearOption.push({
                label: i,
                value: i,
            });
        }
    };

    setYearOption();

    return {
        yearOption,
        currentYear,
        recordStartYear,
        setYearOption,
    }
};